<template lang="pug">
  .service-container
    banner(page='booking_services_page' :customBanner='categoryBanner')
    category-services(:category='category' :services='catservice' v-if='category')
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import CategoryServices from './reusable/category-services.vue'
import Banner from './reusable/banner.vue'
import { fullUrl } from '@/modules/services/utilities'

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('bookingService')

export default {
  name: 'CategoryShow',
  components: {
    CategoryServices,
    Banner
  },
  computed: {
    ...mapState(['categories']),
    ...mapGetters(['objectById', 'services']),
    category () {
      return this.objectById('categories', this.categorySlug)
    },

    categoryBanner () {
      if (this.category.attributes.banner) {
        return { attributes: { image: this.category.attributes.banner, link: this.category.attributes['banner-link'] } }
      } else {
        return null
      }
    },
    categoryId () {
      if (this.category.id) {
        return { attributes: { id: this.category.id } }
      }
      return {}
    },
    categorySlug () {
      return this.$route.params['id']
    },

    catservice () {
      if (this.category && this.category.relationships && this.category.relationships.services) {
        const serviceIds = this.category.relationships.services.data.map(service => service.id)
        return this.services.filter(service => serviceIds.includes(service.id) && service.attributes['status'] === 'published')
      }
      return []
    }
  },
  watch: {
    categoryId (newVal) {
      if (newVal) {
        this.fetchCategory(newVal.attributes.id)
        // this.setservices()
      }
    },
    category (newVal) {
      this.updateSeoFields(newVal)
      if (!this.$route.hash) {
        this.$scrollTo('#header', 200)
      }
    }
  },
  mounted () {
    if (this.categoryId.attributes.id) {
      this.fetchCategory(this.categoryId.attributes.id).then(() => {
        this.updateSeoFields(this.category)
      })
    }
  },
  methods: {
    ...mapActions(['fetchCategory']),
    updateSeoFields (category) {
      if (category?.attributes?.seo) {
        this.$store.commit('setSeoMetaTitle', category.attributes.seo.title)
        this.$store.commit('setSeoMetaDescription', category.attributes.seo.description)
        this.$store.commit('setSeoUpdate', true)
        this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .service-container {
    @include media-breakpoint-down(md) {
      padding-right: 5px;
      padding-left: 5px;
    }
  }
</style>
